module.exports = __webpack_public_path__ + "static/media/5DPO16.c6ab2e00.jpg";